import dateRangeBaseValidator from './dateRange';

export default dateRangeBaseValidator;
